import styled from "styled-components";

export const ActionGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${props => props.spaced ? '20px' : 0};
`;